angular
.module('app.filters')
.filter('selectedTagsLawyers', [
    '$log', function($log) {
      return function(lawyersList, selectedPractice) {
        var filteredLawyers;
        filteredLawyers = [];
        lawyersList.forEach(function(lawyer, index, array) {
          if (lawyer.ref_practices) {
            lawyer.ref_practices.forEach(function(pa, p_index, array) {
              if (pa.practice_ID === selectedPractice && pa.lawyer_practices.isSelected) {
                filteredLawyers.push(lawyer);
              }
            });
          }
        });
        return filteredLawyers;
      };
    }
  ])


// WEBPACK FOOTER //
// ./scripts/shared/filters/selected-tags-lawyers.js